<template>
  <div>
    <div
      style="
        font-family: arial !important;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <div style="font-size: 30px; text-align: center; margin-bottom: 15px">
        Vista Previa de Impresión de Factura Electrónica V2
      </div>
      <div style="text-align: center">
        <button style="font-size: 18px" @click="Print()">Imprimir</button>
        &nbsp;&nbsp;
        <button style="font-size: 18px" @click="Download()">Descargar</button>
        &nbsp;&nbsp;
        <button v-if="!hideQr" style="font-size: 18px" @click="sendMail()">
          Enviar Correo
        </button>
        &nbsp;&nbsp;
        <button v-if="!hideQr" style="font-size: 18px" @click="downLoadJSON()">
          Descargar JSON
        </button>
        <download-invalidation-json :header="dataProps.data.header" />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button
          v-if="!hideQr"
          style="font-size: 18px"
          @click="$emit('input', 'ticket')"
        >
          Ver en formato ticket
        </button>
      </div>
      <div v-if="loading" style="text-align: center">Cargando...</div>
    </div>
    <div
      style="
        font-family: arial !important;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <div v-if="mailLabel" style="text-align: center;">
        {{ mailLabel }}
      </div>
    </div>
    <div
      class="book"
      style="
        margin: 0;
        padding: 0;
        background-color: rgb(105, 105, 105);
        font-family: arial !important;
        padding-top: 20px;
        padding-bottom: 20px;
      "
    >
      <div style="margin: 0 auto; width: 1000px">
        <div
          ref="dataprint"
          style="margin: 0 !important; padding: 0 !important; font-family: Arial !important;"
        >
          <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
          <div
            v-for="(page, indexPage) in pages"
            :key="indexPage"
            style="
              position: relative;
              width: 1000px;
              min-height: 1293px;
              background: white;
            "
          >
            <hr />
            <div
              class="subpage"
              style="height: 1250px; padding-top: 20px; overflow: hidden"
            >
              <div style="margin-left: 80px; margin-right: 50px">
                <div v-if="hideQr" style="width: 100%; background-color: red">
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO SIN VALIDEZ LEGAL
                  </h3>
                </div>

                <div
                  v-if="dataProps.data.header.FeMhEstado == 'RECHAZADO'"
                  style="width: 100%; background-color: red"
                >
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO RECHAZADO POR HACIENDA
                  </h3>
                </div>

                <div
                  v-if="dataProps.data.header.FeMhEstado == 'INVALIDADO'"
                  style="width: 100%; background-color: red"
                >
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO INVALIDADO POR HACIENDA
                  </h3>
                </div>
                <div
                  style="
                    display: inline-block;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <div
                    style="
                      display: inline-block;
                      margin: 0;
                      padding: 0;
                      width: 40%;
                      vertical-align: top;
                    "
                  >
                    <table
                      style="
                        font-size: 10pt;
                        border-collapse: collapse;
                        width: 100%;
                        display: inline-block;
                        vertical-align: top;
                      "
                    >
                    
                      <tr>
                        <!-- logo agencia gloria plemel -->
                        <template v-if="['d5bd8dc2c937c9cf759a38dbf4390d0d'].includes(keyMaster)">
                            <div style="display:flex; justify-content: center; align-items: center">
                                <td :style="`padding-right:20px; padding-bottom: 5px; color: white !important; ${keyMaster === 'a2408f8e0bb20a7225d65c886bd15b2e' ? 'text-align: center' : 'text-align: left'}`">
                                    <img v-if="dataProps.data.branch?.BranchLogoPath != null && dataProps.data.branch?.BranchLogoPath != '' && dataProps.data.branch?.BranchLogoPath != 'null'" style="max-width: 330px !important; height: auto; max-height: 200px !important;" :src="dataProps.data.branch.BranchLogoPath" crossorigin="anonymous" />
                                </td>
                            </div>   
                        </template>
                        <!-- logo otros negocios -->
                        <template v-else>
                          <td
                            style="
                              padding-right: 20px;
                              padding-bottom: 5px;
                              color: white !important;
                            "
                          >
                            <img
                              v-if="dataProps.data.branch?.BranchLogoPath != null && dataProps.data.branch?.BranchLogoPath != '' && dataProps.data.branch?.BranchLogoPath != 'null'"
                              style="
                                max-width: 330px !important;
                                height: auto;
                                max-height: 100px !important;
                              "
                              :src="dataProps.data.branch.BranchLogoPath"
                              crossorigin="anonymous"
                            />
                          </td>
                        </template>
                      </tr>
                      <tr></tr>
                      <tr
                        v-if="
                          dataProps.data.branch.BranchBilledInfo == null ||
                          dataProps.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td
                          style="
                            padding-right: 20px;
                            padding-bottom: 5px;
                            font-size: 12pt;
                          "
                        >
                          <b> {{ dataProps.data.user.business }}</b>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          dataProps.data.branch.BranchBilledInfo == null ||
                          dataProps.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          {{ dataProps.data.branch.BusinessBillingName }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          dataProps.data.branch.BranchBilledInfo == null ||
                          dataProps.data.branch.BranchBilledInfo == ''
                        "
                      >
                      <td style="padding-right: 20px; padding-bottom: 5px">
                        {{ dataProps.data.header.EmisorDescActividad }}
                      </td>
                      </tr>
                      <tr
                        v-if="
                          dataProps.data.branch.BranchBilledInfo == null ||
                          dataProps.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          {{ dataProps.data.branch.BranchLegalAddress }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          dataProps.data.branch.BranchBilledInfo == null ||
                          dataProps.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          Tel. {{ dataProps.data.branch.BranchPhone }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          dataProps.data.branch.BranchBilledInfo == null ||
                          dataProps.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          Whatsapp. {{ dataProps.data.branch.BranchMobile }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          dataProps.data.branch.BranchBilledInfo == null ||
                          dataProps.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          {{ dataProps.data.branch.BranchEmail }}
                        </td>
                      </tr>

                      <tr
                        v-if="
                          dataProps.data.branch.BranchBilledInfo != null &&
                          dataProps.data.branch.BranchBilledInfo != ''
                        "
                      >
                        <td
                          style="padding-right: 20px; padding-bottom: 5px"
                          v-html="modifiedBranchBilledInfo"
                        ></td>
                      </tr>

                      <tr>
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          NIT: {{ BillingNit }}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          NRC: {{ BillingNrc }}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <!-- cuadrado dialogo tipo de factura -->
                  <div
                    style="
                      display: inline-block;
                      margin: 0;
                      padding: 0;
                      width: 60%;
                      vertical-align: top;
                      box-sizing: border-box;
                    "
                  >
                    <table
                      style="
                        font-size: 10pt;
                        border-collapse: collapse;
                        width: 100%;
                        border: 0.5px solid;
                      "
                    >
                      <tr
                        :style="`background-color: ${
                          specialinvoicescolor || 'gray'
                        }; color: ${
                          specialInvoicesTitleColor || 'white'
                        }; width: 100% !important;`"
                      >
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                            padding-top: 5px;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          {{
                            dataProps.data.header.InvoiceType == "FCF"
                              ? "FACTURA CONSUMIDOR FINAL"
                              : ""
                          }}
                          {{
                            dataProps.data.header.InvoiceType == "CCF"
                              ? "COMPROBANTE DE CRÉDITO FISCAL"
                              : ""
                          }}
                          {{
                            dataProps.data.header.InvoiceType == "FNS"
                              ? "FACTURA SUJETO EXCLUIDO"
                              : ""
                          }}
                          {{
                            dataProps.data.header.InvoiceType == "FEX"
                              ? "FACTURA DE EXPORTACIÓN"
                              : ""
                          }}
                          {{
                            dataProps.data.header.InvoiceType == "DNC"
                              ? "NOTA DE CRÉDITO"
                              : ""
                          }}
                          {{
                            dataProps.data.header.InvoiceType == "DND"
                              ? "NOTA DE DÉBITO"
                              : ""
                          }}
                          {{
                            dataProps.data.header.InvoiceType == "CDD"
                              ? "COMPROBANTE DE DONACIÓN"
                              : ""
                          }}
                          {{
                            dataProps.data.header.InvoiceType == "DNR"
                              ? "NOTA DE REMISIÓN"
                              : ""
                          }}
                        </td>
                      </tr>
                      <tr v-if="dataProps.data.header.InvoiceType != 'FER'">
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Código generación:</b>
                        </td>
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                            padding-top: 10px;
                          "
                        >
                          {{ dataProps.data.header.CodigoGeneracion }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Sello de recepción:</b>
                        </td>
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ dataProps.data.header.SelloRecepcion }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Número de control:</b>
                        </td>
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ dataProps.data.header.NumeroControl }}
                        </td>
                      </tr>
                      <tr>
                        <template
                          v-if="
                            dataProps.data.header.InvoiceStatusDescription ==
                            'Cancelada' || isContadoEspecial
                          "
                        >
                          <td
                            colspan="2"
                            style="
                              padding-left: 10px;
                              padding-right: 10px;
                              padding-bottom: 5px;
                            "
                          >
                            <b>Fecha emisión:</b>
                          </td>
                          <td
                            colspan="2"
                            style="
                              padding-left: 10px;
                              padding-right: 10px;
                              padding-bottom: 5px;
                            "
                          >
                            {{ dataProps.data.header.InvoiceDate }}
                          </td>
                        </template>
                        <template v-else>
                          <td
                            colspan="2"
                            style="
                              width: 50% !important;
                              padding-left: 10px;
                              padding-right: 10px;
                              padding-bottom: 5px;
                            "
                          >
                            <b>Fecha emisión:</b>&nbsp;
                            {{ dataProps.data.header.InvoiceDate }}
                          </td>
                          <td
                            colspan="2"
                            style="
                              width: 50% !important;
                              padding-left: 10px;
                              padding-right: 10px;
                              padding-bottom: 5px;
                            "
                          >
                            <b>Fecha vencimiento:</b>&nbsp; {{ dateWithDays }}
                          </td>
                        </template>
                      </tr>
                      <tr>
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Correlativo factura:</b>
                        </td>
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ dataProps.data.header.ID_Invoice }}
                        </td>
                      </tr>
                      <tr v-if="ShowCorrelativeControl">
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Correlativo interno:</b>
                        </td>
                        <td
                          colspan="2"
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ dataProps.data.header.InvoiceType + "-" + dataProps.data.header.Correlative_ID_Invoice }}
                        </td>
                      </tr>
                      <tr v-if="!hideQr">
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                            text-align: center;
                          "
                          colspan="4"
                        >
                          <img ref="qrcode" :src="urlQr" style="width: 135px;" />
                        </td>
                      </tr>
                    </table>
                    <table
                      style="
                        font-size: 10pt;
                        border-collapse: collapse;
                        width: 100%;
                      "
                    >
                      <tr>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                        >
                          <b>Modelo de facturación:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                          v-if="
                            dataProps.data.dteJson.IdentificacionTipoModelo == 1
                          "
                        >
                          Previo
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                          v-if="
                            dataProps.data.dteJson.IdentificacionTipoModelo == 2
                          "
                        >
                          Diferido
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                        >
                          <b>Tipo de transmisión:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                          v-if="
                            dataProps.data.dteJson
                              .IdentificacionTipoOperacion == 1
                          "
                        >
                          Normal
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                          v-if="
                            dataProps.data.dteJson
                              .IdentificacionTipoOperacion == 2
                          "
                        >
                          Por contingencía
                        </td>
                      </tr>
                      <tr></tr>
                    </table>
                  </div>
                </div>

                <br />
                <hr />
                <div
                  style="width: 100%"
                  v-if="
                    dataProps.data.branch.BranchBannerPath != null &&
                    dataProps.data.branch.BranchBannerPath != '' &&
                    dataProps.data.branch.BranchBannerPath != 'null'
                  "
                >
                  <table
                    style="
                      font-size: 10pt;
                      border-collapse: collapse;
                      width: 100%;
                    "
                  >
                    <tr>
                      <td
                        style="
                          padding-left: 0px;
                          padding-right: 0px;
                          padding-bottom: 0px;
                          text-align: center;
                        "
                      >
                        <img
                          v-if="dataProps.data.branch?.BranchLogoPath != null && dataProps.data.branch?.BranchLogoPath != '' && dataProps.data.branch?.BranchLogoPath != 'null'"
                          style="max-height: 220px"
                          :src="dataProps.data.branch.BranchBannerPath"
                          width="100%"
                        />
                      </td>
                    </tr>
                  </table>
                </div>
               
                <br />
                <!-- Fin cuadrado dialogo tipo de factura -->
                <!-- Encabezado detalle de facturas -->
                <div style="width: 100%">
                  <table
                    style="
                      font-size: 10pt;
                      border-collapse: collapse;
                      width: 100%;
                    "
                    v-if="dataProps.data.header.InvoiceType != 'CCF'"
                  >
                    <tr
                      v-if="
                        dataProps.data.header.ID_Seller &&
                        keyMaster !== '22ddfc1b81d28286daec551efa268b0d'
                      "
                    >
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Código cliente:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ID_Customer }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Código vendedor:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ID_Seller }}
                      </td>
                    </tr>
                    <tr
                      v-else-if="
                        keyMaster == '22ddfc1b81d28286daec551efa268b0d'
                      "
                    >
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Código cliente:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ID_Customer }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Correo cliente:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.customerEmail || dataProps.data.dteJson.ReceptorCorreo }}
                      </td>
                    </tr>
                    <tr v-else>
                      <td
                        v-if="!dataProps.data.header.ID_Seller"
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Código cliente:</b>
                      </td>
                      <td
                        v-if="!dataProps.data.header.ID_Seller"
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ID_Customer }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Razón social:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceName }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Dirección:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                          width: 300px !important;
                        "
                      >
                        {{ dataProps.data.header.InvoiceAddress }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NIT:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceNIT }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>DUI:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceDUI }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Entidad:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceEntity }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b v-if="['9593c3ca31b86c09c9b764c5baddf846'].includes(keyMaster)">Metodo de pago:</b>
                        <b v-else>Moneda:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <template v-if="['9593c3ca31b86c09c9b764c5baddf846'].includes(keyMaster)">
                          {{ getMetodoPago(dataProps.data.header) }}
                        </template>
                        <template v-else>
                          {{ dataProps.data.header.InvoiceCurrency == "$"? "USD" : "" }}
                        </template>
                      </td>

                      <td
                        v-if="
                          dataProps.data.header.ZoneClient != '' &&
                          dataProps.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Zona:</b>
                      </td>
                      <td
                        v-if="
                          dataProps.data.header.ZoneClient != '' &&
                          dataProps.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ZoneClient }}
                      </td>
                    </tr>
                    <template v-if="!romerolascascadasdata">
                      <tr v-if="!lexlitislatamclientdata">
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Estado de la factura:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{  getEstadoFactura()  }}
                        </td>
                      </tr>
                    </template>

                    <tr v-if="keyMaster !== '22ddfc1b81d28286daec551efa268b0d'">
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Correo cliente:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.customerEmail || dataProps.data.dteJson.ReceptorCorreo}}
                      </td>
                    </tr>
                    <template v-if="keyMaster === 'f6daed50da50e4b0b0d6a514924b4ba8'">
                      <tr>
                        <td
                        style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        ><b>Responsable por parte del Emisor:</b></td>
                        <td></td>
                        <td
                        style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        ><b>No. documento:</b></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td
                        style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        ><b>Responsable por parte del Receptor:</b></td>
                        <td></td>
                        <td
                        style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        ><b>No. documento:</b></td>
                        <td></td>
                      </tr>
                    </template>
                    
                  </table>
                  <table
                    style="
                      font-size: 10pt;
                      border-collapse: collapse;
                      width: 100%;
                    "
                    v-else-if="kitcoalternativeposclientdata"
                  >
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Razón social:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceName }}
                      </td>

                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NIT:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceNIT }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Dirección:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                          width: 300px !important;
                        "
                      >
                        {{ dataProps.data.header.InvoiceAddress }}
                      </td>

                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NRC:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceNRC }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Actividad económica:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.dteJson.ReceptorDescActividad }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Forma de pago:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceStatusDescription }}
                      </td>

                      <td
                        v-if="
                          dataProps.data.header.ZoneClient != '' &&
                          dataProps.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Zona:</b>
                      </td>
                      <td
                        v-if="
                          dataProps.data.header.ZoneClient != '' &&
                          dataProps.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ZoneClient }}
                      </td>
                    </tr>
                    <tr v-if="keyMaster !== '22ddfc1b81d28286daec551efa268b0d'">
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Correo cliente:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.customerEmail || dataProps.data.dteJson.ReceptorCorreo}}
                      </td>
                    </tr>
                  </table>
                  <table
                    style="
                      font-size: 10pt;
                      border-collapse: collapse;
                      width: 100%;
                    "
                    v-else
                  >
                    <tr
                      v-if="
                        dataProps.data.header.ID_Seller &&
                        keyMaster !== '22ddfc1b81d28286daec551efa268b0d'
                      "
                    >
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Código cliente:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ID_Customer }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Código vendedor:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ID_Seller }}
                      </td>
                    </tr>
                    <tr
                      v-else-if="
                        keyMaster == '22ddfc1b81d28286daec551efa268b0d'
                      "
                    >
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Código cliente:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ID_Customer }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Correo cliente:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.customerEmail || dataProps.data.dteJson.ReceptorCorreo}}
                      </td>
                    </tr>
                    <tr v-else>
                      <td
                        v-if="!dataProps.data.header.ID_Seller"
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Código cliente:</b>
                      </td>
                      <td
                        v-if="!dataProps.data.header.ID_Seller"
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.ID_Customer }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Razón social:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceName }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Dirección:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                          width: 300px !important;
                        "
                      >
                        {{ dataProps.data.header.InvoiceAddress }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NIT:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceNIT }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NRC:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceNRC }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Entidad:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.InvoiceEntity }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Actividad económica:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.dteJson.ReceptorDescActividad }}
                      </td>

                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b v-if="['9593c3ca31b86c09c9b764c5baddf846'].includes(keyMaster)">Metodo de pago:</b>
                        <b v-else>Moneda:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                      <template v-if="['9593c3ca31b86c09c9b764c5baddf846'].includes(keyMaster)">
                        {{ getMetodoPago(dataProps.data.header) }}
                      </template>
                      <template v-else>
                        {{ dataProps.data.header.InvoiceCurrency == "$"? "USD" : "" }}
                        </template>
                      </td>
                    </tr>
                    <template v-if="!romerolascascadasdata">
                      <tr v-if="!lexlitislatamclientdata">
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Estado de la factura:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ getEstadoFactura() }}
                        </td>

                        <td
                          v-if="
                            dataProps.data.header.ZoneClient != '' &&
                            dataProps.data.header.ZoneClient != null
                          "
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Zona:</b>
                        </td>
                        <td
                          v-if="
                            dataProps.data.header.ZoneClient != '' &&
                            dataProps.data.header.ZoneClient != null
                          "
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ dataProps.data.header.ZoneClient }}
                        </td>
                      </tr>
                      <tr v-else>
                        <td
                          v-if="
                            dataProps.data.header.ZoneClient != '' &&
                            dataProps.data.header.ZoneClient != null
                          "
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Zona:</b>
                        </td>
                        <td
                          v-if="
                            dataProps.data.header.ZoneClient != '' &&
                            dataProps.data.header.ZoneClient != null
                          "
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ dataProps.data.header.ZoneClient }}
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td
                          v-if="
                            dataProps.data.header.ZoneClient != '' &&
                            dataProps.data.header.ZoneClient != null
                          "
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Zona:</b>
                        </td>
                        <td
                          v-if="
                            dataProps.data.header.ZoneClient != '' &&
                            dataProps.data.header.ZoneClient != null
                          "
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ dataProps.data.header.ZoneClient }}
                        </td>
                      </tr>
                    </template>
                    <tr v-if="keyMaster !== '22ddfc1b81d28286daec551efa268b0d'">
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Correo cliente:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ dataProps.data.header.customerEmail || dataProps.data.dteJson.ReceptorCorreo}}
                      </td>
                    </tr>
                  </table>
                  <table
                    v-if="
                      (keyMaster == '22ddfc1b81d28286daec551efa268b0d' ||
                        keyMaster == '1f4e233a5eef560814ecf400f0e4c642') &&
                      dataProps.data.header.FullNameSeller
                    "
                    style="
                      font-size: 10pt;
                      border-collapse: collapse;
                      width: 100%;
                    "
                  >
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-top: 5px;
                          text-align: left;
                          width: 100px;
                        "
                      >
                        <b>Vendedor:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-top: 5px;
                          text-align: left;
                        "
                      >
                        {{
                          dataProps.data.header.FullNameSeller
                            ? dataProps.data.header.FullNameSeller
                            : ""
                        }}
                      </td>
                    </tr>
                  </table>
                </div>
                <template
                  v-if="
                    dataProps.data.dteJson.VentaTerceroNit &&
                    dataProps.data.dteJson.VentaTerceroNombre
                  "
                >
                  <br />
                  <div style="width: 100%">
                    <table
                      style="
                        width: 100% !important;
                        font-size: 11px;
                        border-collapse: collapse;
                        border: 1px solid black;
                      "
                    >
                      <tr style="background: gray">
                        <td
                          colspan="3"
                          style="text-align: center; color: white"
                        >
                          VENTA POR CUENTA DE TERCEROS
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 1px solid;
                            padding-left: 2px;
                            width: 35px;
                          "
                        >
                          NIT
                        </td>
                        <td
                          style="
                            border: 1px solid;
                            padding-left: 2px;
                            width: 35px;
                          "
                        >
                          Nombre, denominación o razón social
                        </td>
                      </tr>

                      <tr>
                        <td
                          style="
                            border-left: 1px solid;
                            border-right: 1px solid;
                          "
                        >
                          {{ dataProps.data.dteJson.VentaTerceroNit }}
                        </td>
                        <td
                          style="
                            border-left: 1px solid;
                            border-right: 1px solid;
                          "
                        >
                          {{ dataProps.data.dteJson.VentaTerceroNombre }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </template>
                <template
                  v-if="
                    dataProps.data.header.InvoiceType == 'DNC' ||
                    dataProps.data.header.InvoiceType == 'DND'
                  "
                >
                  <br />
                  <div style="width: 100%">
                    <table
                      style="
                        width: 100% !important;
                        font-size: 11px;
                        border-collapse: collapse;
                        border: 1px solid black;
                      "
                    >
                      <tr style="background: gray">
                        <td
                          colspan="3"
                          style="text-align: center; color: white"
                        >
                          DOCUMENTOS RELACIONADOS
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 1px solid;
                            padding-left: 2px;
                            width: 35px;
                          "
                        >
                          Tipo de Documento
                        </td>
                        <td
                          style="
                            border: 1px solid;
                            padding-left: 2px;
                            width: 35px;
                          "
                        >
                          Nº de Documento
                        </td>
                        <td
                          style="
                            border: 1px solid;
                            padding-left: 2px;
                            width: 35px;
                          "
                        >
                          Fecha de Documento
                        </td>
                      </tr>

                      <tr
                        v-for="(item, index) in relatedDocuments"
                        :key="index"
                      >
                        <td
                          style="
                            border-left: 1px solid;
                            border-right: 1px solid;
                          "
                        >
                          {{
                            item.TipoDocumentoRelacionado == "03"
                              ? "Comprobante de Crédito Fiscal"
                              : ""
                          }}
                        </td>
                        <td
                          style="
                            border-left: 1px solid;
                            border-right: 1px solid;
                          "
                        >
                          {{ item.NumeroDocumentoRelacionado }}
                        </td>
                        <td
                          style="
                            border-left: 1px solid;
                            border-right: 1px solid;
                          "
                        >
                          {{ item.FechaEmisionRelacionado }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </template>

                <br />
                <!-- Fin Encabezado detalle de facturas -->
                <div style="width: 100%">
                  <table
                    style="
                      width: 100% !important;
                      font-size: 11px;
                      border-collapse: collapse;
                      border: 1px solid black;
                    "
                  >
                    <tr
                      :style="`background: ${
                        specialinvoicescolor || 'gray'
                      }; color: ${specialInvoicesTitleColor || 'white'};`"
                    >
                      <td colspan="12" style="text-align: center">
                        CUERPO DEL DOCUMENTO
                      </td>
                    </tr>

                    <tr>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 35px;
                        "
                      >
                        No.<br />Item
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 35px;
                        "
                      >
                        Tipo<br />Item
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 35px;
                        "
                      >
                        Cant.
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 95px;
                        "
                        v-if="!['ac7d98c7e5d0db964018ac969140297c'].includes(keyMaster)"
                      >
                        Código
                      </td>
                      <td v-if="posshowprincipalbarcode"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                        "
                       :style="{ 'width': ['ac7d98c7e5d0db964018ac969140297c'].includes(keyMaster)?'150px':'95px' }"
                      >
                        Código<br />Alterno
                      </td>
                      <td style="border: 1px solid; padding-left: 2px">
                        Descripcion
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Precio<br />unitario
                        {{ dataProps.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Descuento {{ dataProps.data.header.InvoiceCurrency }}
                      </td>
                      <td v-if="['CCF', 'FCF', 'FEX'].includes(dataProps.data.header.InvoiceType)"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Otros montos no afectos
                        {{ dataProps.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="dataProps.data.header.InvoiceType != 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Ventas<br />exentas
                        {{ dataProps.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="dataProps.data.header.InvoiceType != 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Ventas no<br />sujetas
                        {{ dataProps.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="dataProps.data.header.InvoiceType != 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Ventas <br />gravadas
                        {{ dataProps.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="dataProps.data.header.InvoiceType == 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Ventas <br />afectas
                        {{ dataProps.data.header.InvoiceCurrency }}
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index) in valuesRows[indexPage]"
                      :key="index"
                    >
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                     
                        {{
                          item.itemNum
                        }}
                      </td>
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        3
                      </td>
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        {{ item.ItemQuantity }}
                      </td>
                      <td
                      v-if="!['ac7d98c7e5d0db964018ac969140297c'].includes(keyMaster)"
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        {{ item.ID_Item }}
                      </td>
                      <td v-if="posshowprincipalbarcode"
                        style="border-left: 1px solid; border-right: 1px solid;"
                        :style="{ 'width': ['ac7d98c7e5d0db964018ac969140297c'].includes(keyMaster)?'150px':'95px' }"
                      >
                        <div style="display: inline-block; overflow: hidden; white-space: nowrap;" :style="{ 'width': ['ac7d98c7e5d0db964018ac969140297c'].includes(keyMaster)?'150px':'90px'}">
                          {{ item.PrincipalBarCode }}
                        </div>
                      </td>
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        {{ item.ItemDescription }}
                      </td>
                      <td
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          (item.ItemNoGravada > 0) ? 0 : numberWithCommas(parseFloat(item.ItemUnitPrice).toFixed(2))
                        }}
                      </td>
                      <td
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemDiscount)
                          )
                        }}
                      </td>
                      <td
                        v-if="['CCF', 'FCF', 'FEX'].includes(dataProps.data.header.InvoiceType)"
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemNoGravada)
                          )
                        }}
                      </td>
                      <td
                        v-if="dataProps.data.header.InvoiceType != 'FEX'"
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemExenta)
                          )
                        }}
                      </td>
                      <td
                        v-if="dataProps.data.header.InvoiceType != 'FEX'"
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemNoSuj)
                          )
                        }}
                      </td>
                      <td
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemGravada)
                          )
                        }}
                      </td>
                    </tr>

                    <tr v-if="indexPage == numPages - 1">
                      <td
                        colspan="6"
                        style="border: 1px solid; padding: 4px; text-transform: uppercase;"
                      >
                        <div :style="{textAlign:showAnticiposDetail?'left':'center', marginBottom: '6px'}">
                          <b>Valor en letras: </b>
                          {{ dataProps.data.header.InvoiceTotalLetras }}
                        </div>
                        <tr v-if="showAnticiposDetail" style="margin-top: 8px;">
                          <td colspan="3">
                            <span style="font-size: 9pt; font-weight: 600; text-align: left;">
                              INFORMACION DE PAGOS
                            </span>
                          </td>
                        </tr>
                        <tr style="font-size: 12px; text-align: left;" v-if="showAnticiposDetail">
                          <td> 
                              Anticipo:
                          </td>
                          <td> 
                              {{ dataProps.data.header.InvoiceCurrency }}
                          </td>
                          <td>
                              {{ numberWithCommas(parseFloat( getTotalAnticipo )) }}
                          </td>
                        </tr>
                        <tr style="font-size: 12px; text-align: left;" v-if="showAnticiposDetail">
                          <td> 
                              Abono final:
                          </td>
                          <td> 
                              {{ dataProps.data.header.InvoiceCurrency }}
                          </td>
                          <td>
                              {{ numberWithCommas(parseFloat( dataProps.data.header.InvoiceTotalPagar - getTotalAnticipo )) }}
                          </td>
                        </tr>
                      </td>

                      <td colspan="6" style="border: 1px solid">
                        <table
                          style="
                            width: 100% !important;
                            font-size: 11px;
                            text-align: right;
                          "
                        >
                          <template
                            v-if="dataProps.data.header.InvoiceType == 'CCF'"
                          >
                            <tr>
                              <td>Sub total ventas gravadas</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header
                                        .InvoiceSubTotalVentas
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total descuentos</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalDescu
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="parseFloat(dataProps.data.header.TurismoPorAlojamiento) > 0"
                            >
                              <td>Imp. turismo</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.TurismoPorAlojamiento
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="showIvaTotal()">
                              <td>IVA</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalIva
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Sub total</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalGravada + dataProps.data.header.InvoiceTotalIva
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>IVA Retenido</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceIvaRete1
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>IVA Percibido</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceIvaPerce1
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Impuesto sobre la renta</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceReteRenta
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="
                                parseFloat(dataProps.data.header.Fovial) > 0
                              "
                            >
                              <td>Fovial</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.Fovial
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="
                                parseFloat(dataProps.data.header.Cotrans) > 0
                              "
                            >
                              <td>Cotrans</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.Cotrans
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="dataProps.data.header.InvoiceTotalExenta > 0">
                              <td>Ventas exentas</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalExenta
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="dataProps.data.header.InvoiceTotalNoSuj > 0">
                              <td>Ventas no sujetas</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalNoSuj
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="dataProps.data.header.InvoiceTotalNoGravado > 0">
                              <td>Total otros montos no afectos</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalNoGravado
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Total</b></td>
                              <td>
                                <b>{{
                                  dataProps.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalPagar
                                    )
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>

                          <template
                            v-if="
                              dataProps.data.header.InvoiceType == 'FCF' ||
                              dataProps.data.header.InvoiceType == 'CDD' ||
                              dataProps.data.header.InvoiceType == 'DNR'
                            "
                          >
                            <tr>
                              <td>Sub total de ventas</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header
                                        .InvoiceTotalGravada
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total descuentos</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalDescu
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="parseFloat(dataProps.data.header.TurismoPorAlojamiento) > 0"
                            >
                              <td>Imp. turismo</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.TurismoPorAlojamiento
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>IVA Retenido</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceIvaRete1
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Impuesto sobre la renta</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceReteRenta
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="
                                parseFloat(dataProps.data.header.Fovial) > 0
                              "
                            >
                              <td>Fovial</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.Fovial
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="
                                parseFloat(dataProps.data.header.Cotrans) > 0
                              "
                            >
                              <td>Cotrans</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.Cotrans
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalExenta) > 0">
                              <td>Ventas exentas</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalExenta
                                    )
                                  )
                                }}
                              </td>
                            </tr>

                            <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalNoSuj) > 0">
                              <td>Ventas no sujetas</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalNoSuj
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalNoGravado) > 0">
                              <td>Total otros montos no afectos</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalNoGravado
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Total</b></td>
                              <td>
                                <b>{{
                                  dataProps.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalPagar
                                    )
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>

                          <template
                            v-if="dataProps.data.header.InvoiceType == 'FEX'"
                          >
                            <tr>
                              <td>Total de Operaciones Afectas</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header
                                        .InvoiceSubTotalVentas
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Monto global de Desc., Rebajas de operaciones
                                afectas
                              </td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalDescu
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="dataProps.data.header.InvoiceType === 'FEX'"
                            >
                              <td>Flete</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.Flete
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="dataProps.data.header.InvoiceType === 'FEX'"
                            >
                              <td>Seguro</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.Seguro
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(dataProps.data.header.InvoiceTotalNoGravado) > 0">
                              <td>Total otros montos no afectos</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalNoGravado
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Monto Total de la Operación</b></td>
                              <td>
                                <b>{{
                                  dataProps.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalPagar
                                    )
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>

                          <template
                            v-if="dataProps.data.header.InvoiceType == 'FNS'"
                          >
                            <tr>
                              <td>Sub total de ventas</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header
                                        .InvoiceSubTotalVentas
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total descuentos</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalDescu
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>IVA Retenido</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceIvaRete1
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Impuesto sobre la renta</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceReteRenta
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="dataProps.data.header.InvoiceType === 'FEX'"
                            >
                              <td>Flete</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.Flete
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="dataProps.data.header.InvoiceType === 'FEX'"
                            >
                              <td>Seguro</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.Seguro
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Total</b></td>
                              <td>
                                <b>{{
                                  dataProps.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalPagar
                                    )
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>

                          <template
                            v-if="
                              dataProps.data.header.InvoiceType == 'DNC' ||
                              dataProps.data.header.InvoiceType == 'DND'
                            "
                          >
                            <tr>
                              <td>Sub total de ventas</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header
                                        .InvoiceSubTotalVentas
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Monto global Des., Rebajas y otros a ventas no
                                sujetas
                              </td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceDescuNoSuj
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Monto global Des., Rebajas y otros a ventas
                                exentas
                              </td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceDescuExenta
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Monto global Des., Rebajas y otros a ventas
                                gravadas
                              </td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceDescuGravada
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="parseFloat(dataProps.data.header.TurismoPorAlojamiento) > 0"
                            >
                              <td>Imp. turismo</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.TurismoPorAlojamiento
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="showIvaTotal()">
                              <td>Impuesto al Valor Agregado 13%</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalIva
                                    )
                                  )
                                }}
                              </td>
                            </tr>            
                            <tr>
                              <td>IVA Retenido</td>
                              <td>
                                {{ dataProps.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceIvaRete1
                                    )
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Total</b></td>
                              <td>
                                <b>{{
                                  dataProps.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      dataProps.data.header.InvoiceTotalPagar
                                    )
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>
                          <tr v-if="dataProps.data.header.InvoiceType === 'FER' && !showIvaTotal()">
                            <td>Impuesto sobre la renta</td>
                            <td>{{ dataProps.data.header.InvoiceCurrency }}</td>
                            <td style="text-align: right; width: 50px">
                              {{ numberWithCommas((parseFloat(dataProps.data.header.InvoiceReteRenta) || 0).toFixed(2)) }}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <template
                      v-if="
                        dataProps.data.header.InvoiceInternalNote &&
                        keyMaster !== '22ddfc1b81d28286daec551efa268b0d'
                      "
                    >
                      <tr>
                        <td colspan="10" style="padding: 5px">
                          <b>Observaciones: </b> {{ dataProps.data.header.RulesToShowComments != 2 ? commentsOuterHtml : '' }}
                          <h5 style="text-align: center" v-if="['d76ca00b6f45acf9815bc10e1d9b7652'].includes(keyMaster)">
                              NO SE ACEPTAN DEVOLUCIONES
                          </h5>
                        </td>
                      </tr>
                    </template>
                  </table>
                  <!-- Campo responsables facturas -->
                  <div
                    v-if="dataProps.data.header.ShowResponsabilitiesInInvoice || dataProps.data.header.InvoiceTotalPagar >= 25000" 
                    style=" border-collapse: collapse;
                        border: 1px solid black;
                        margin-top: 10px;
                        padding: 10px 0px ;">
                    <table
                      style="
                          width: 100% !important;
                          font-size: 11px;
                        "
                    >
                      <tr>
                        <td style="padding-left: 10px; padding-bottom: 5px">
                          <b>Responsable por parte del Emisor:</b>
                        </td>
                        <td>{{dataProps.data.header.InvoiceExtNombEntrega || dataProps.data.header.FullName}}</td>
                        <td style="padding-right: 10px; padding-bottom: 5px">
                          <b>No. documento:</b>
                        </td>
                        <td>{{dataProps.data.header.InvoiceExtDocuEntrega || dataProps.data.header.EmisorUserDui}}</td>
                        <td style="padding-right: 10px; padding-bottom: 5px">
                          <b>Telefono:</b>
                        </td>
                        <td>{{dataProps.data.header.InvoiceExtTelEntrega || dataProps.data.header.EmisorUserMobile || ' -- ' }}</td>
                      </tr>
                      <tr>
                          <td style="padding-left: 10px; padding-bottom: 5px">
                          <b>Responsable por parte del Receptor:</b>
                          </td>
                          <td>{{ dataProps.data.header.InvoiceExtNombRecibe || dataProps.data.header?.customerInfo?.BusinessContactName || dataProps.data.header.ReceptorNombre || '--' }}</td>
                          <td style="padding-right: 10px; padding-bottom: 5px">
                          <b>No. documento:</b>
                          </td>
                          <td>{{dataProps.data.header.InvoiceExtDocuRecibe || dataProps.data.header?.customerInfo?.dui || dataProps.data.header.ReceptorNumDocumento || dataProps.data.header.ReceptorNit || dataProps.data.header.ReceptorNrc || ' -- '}}</td>
                          <td style="padding-right: 10px; padding-bottom: 5px">
                          <b>Telefono:</b>
                          </td>
                          <td>{{dataProps.data.header.InvoiceExtTelRecibe || dataProps.data.header?.customerInfo?.BusinessContactPhone|| dataProps.data.header.ClienteTelefonoFijoDeContacto || dataProps.data.header.ReceptorTelefono || '--'}}</td>
                      </tr>
                    </table>
                  </div>
                  <!-- Fin Campo responsables facturas mayores a $25K -->
                  <div
                    v-if="indexPage == numPages - 1 && hasAppendixRows"
                    style="margin-top: 10px; text-transform: none; font-size: 9pt; page-break-inside: avoid;"
                  >
                    <table style="width: 100%; font-size: 11px; border-collapse: collapse; table-layout: fixed; border: 1px solid black;">
                      <thead>
                        <tr
                          :style="`background: ${
                            specialinvoicescolor || 'gray'
                          }; color: ${specialInvoicesTitleColor || 'white'};`"
                        >
                          <td colspan="3" style="text-align: center">
                            APENDICE
                          </td>
                        </tr>
                        <tr>
                          <th style="border: 1px solid; padding: 3px; text-align: left; width: 20%;">Campo</th>
                          <th style="border: 1px solid; padding: 3px; text-align: left; width: 35%;">Etiqueta</th>
                          <th style="border: 1px solid; padding: 3px; text-align: left; width: 45%;">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row, index) in appendixRows"
                          :key="`appendix-${index}`"
                        >
                          <td style="border: 1px solid; padding: 3px; word-break: break-word; white-space: normal;">
                            {{ row.campo }}
                          </td>
                          <td style="border: 1px solid; padding: 3px; word-break: break-word; white-space: normal;">
                            {{ row.etiqueta }}
                          </td>
                          <td style="border: 1px solid; padding: 3px; word-break: break-word; white-space: normal;">
                            {{ row.valor }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    v-if="indexPage == numPages - 1 && showGuaranteeInline && guaranteeHtml"
                    style="margin-top: 10px;"
                  >
                    <GuaranteePrintBlock
                      :html="guaranteeHtml"
                      :business-id="guaranteeBusinessId"
                      :branch-id="guaranteeBranchId"
                      guarantee-type="COMPROBANTE"
                      font-size="11px"
                    />
                  </div>
                </div>
              </div>

              <div
                style="position: absolute; bottom: 0; width: 100%; left: 80px"
              >
                <p style="font-size: 10px">
                  Pagina {{ indexPage + 1 }} de {{ totalPages }}
                </p>
              </div>
            </div>
          </div>
        </div>
                        <div
                          v-if="showGuaranteePage"
                          style="
                            position: relative;
                            width: 1000px;
            min-height: 1293px;
            background: white;
          "
        >
          <hr />
                          <div class="subpage" style="height: 1250px; padding-top: 20px; overflow: hidden">
                            <div style="margin-left: 80px; margin-right: 50px">
                              <GuaranteePrintBlock
                                :html="guaranteeHtml"
                                :business-id="guaranteeBusinessId"
                                :branch-id="guaranteeBranchId"
                                guarantee-type="COMPROBANTE"
                                font-size="11px"
                              />
            </div>
            <div style="position: absolute; bottom: 0; width: 100%; left: 80px">
              <p style="font-size: 10px">
                Pagina {{ totalPages }} de {{ totalPages }}
              </p>
                          </div>
                        </div>
                        <div
                          v-if="guaranteeHtml"
                          style="position: fixed; left: -20000px; top: 0; width: 1000px; visibility: hidden; pointer-events: none; z-index: -1;"
                        >
                          <div ref="guaranteeMeasure" style="margin-left: 80px; margin-right: 50px">
                            <GuaranteePrintBlock
                              :html="guaranteeHtml"
                              :business-id="guaranteeBusinessId"
                              :branch-id="guaranteeBranchId"
                              guarantee-type="COMPROBANTE"
                              font-size="11px"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
  </div>
</template>

<script>
import DownloadInvalidationJson from "@/components/ReportsAndPrintings/DownloadInvalidationJson.vue";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc";
import { formatNumber } from "../../helpers/money";
import { numberToText } from "@/helpers/conveterNumberText.js";
import GuaranteePrintBlock from "@/components/ReportsAndPrintings/GuaranteePrintBlock.vue";
import { createGuaranteePlacementState, loadGuaranteeHtml } from "@/components/ReportsAndPrintings/utils/guaranteePlacement";
import { estimateHtmlLines, estimateRowLines } from "@/components/ReportsAndPrintings/utils/printLineEstimator";

export default {
  name: "PrintPosFacturaRegular",
  components: { DownloadInvalidationJson,
    GuaranteePrintBlock,
  },
  model: {
    event: "input",
    prop: "type",
  },
  props: {
    dataProps: {
      type: Object,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ...createGuaranteePlacementState(),
      header: null,
      footer: null,
      loading: false,
      //seal: "",
      //sealBranch: "",
      numPages: 0,

      //valuesRows: []
      mailLabel: null,
      valuesRows: [],
      urlQr: null,
      typePrint: 0,
      lastPageRowsUsed: 0,
      lastPageLimitRows: 0,
      specialinvoicescolor: JSON.parse(localStorage.getItem("user"))
        .specialinvoicescolor,
      specialInvoicesTitleColor: JSON.parse(localStorage.getItem("user"))
        .specialInvoicesTitleColor,
      kitcoalternativeposclientdata: JSON.parse(localStorage.getItem("user"))
        .kitcoalternativeposclientdata,
      lexlitislatamclientdata: JSON.parse(localStorage.getItem("user"))
        .lexlitislatamclientdata,
      romerolascascadasdata: JSON.parse(localStorage.getItem("user"))
        .romerolascascadasdata,
      keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
      ShowCorrelativeControl: JSON.parse(localStorage.getItem("user")).showcorrelativecontrol,
      posshowprincipalbarcode: JSON.parse(localStorage.getItem("user")).posshowprincipalbarcode,
    };
  },
  mounted() {
    this.getHeaderFooter();
    this.showData();
    this.prepareGuarantee();
  },
  computed: {
    BillingNrc() {
      return addFormatNRC(this.dataProps.data.branch.BusinessBillingNRC);
    },
    BillingNit() {
      return addFormatToNIT(this.dataProps.data.branch.BusinessBillingNIT);
    },
    guaranteeBusinessId() {
      return (
        this.dataProps?.data?.branch?.ID_Business ||
        JSON.parse(localStorage.getItem("user"))?.businessid ||
        null
      );
    },
    guaranteeBranchId() {
      return (
        this.dataProps?.data?.branch?.ID_Branch ||
        JSON.parse(localStorage.getItem("branch"))?.ID_Branch ||
        null
      );
    },
    pages() {
      // Generar un arreglo con `numPages` elementos
      return Array.from({ length: this.numPages });
    },
    totalPages() {
      return this.numPages + (this.showGuaranteePage ? 1 : 0);
    },
    showGuaranteePage() {
      return Boolean(this.guaranteeHtml) && !this.showGuaranteeInline;
    },
    tailReserveLines() {
      const header = this.dataProps?.data?.header || {};
      const appendix = this.appendixRows || [];
      const notesLines = header.InvoiceInternalNote && header.RulesToShowComments !== 2
        ? estimateHtmlLines(this.commentsOuterHtml)
        : 0;
      const appendixLines = appendix.reduce((total, row) => total + estimateRowLines([row.campo, row.etiqueta, row.valor]), 0);
      const responsiblesVisible = Boolean(header.ShowResponsabilitiesInInvoice || header.InvoiceTotalPagar >= 25000);
      const responsiblesLines = responsiblesVisible
        ? estimateRowLines([
          header.InvoiceExtNombEntrega || header.FullName || "",
          header.InvoiceExtDocuEntrega || header.EmisorUserDui || "",
          header.InvoiceExtTelEntrega || header.EmisorUserMobile || "",
          header.InvoiceExtNombRecibe || header?.customerInfo?.BusinessContactName || header.ReceptorNombre || "",
          header.InvoiceExtDocuRecibe || header?.customerInfo?.dui || header.ReceptorNumDocumento || header.ReceptorNit || header.ReceptorNrc || "",
          header.InvoiceExtTelRecibe || header?.customerInfo?.BusinessContactPhone || header.ClienteTelefonoFijoDeContacto || header.ReceptorTelefono || "",
        ]) + 2
        : 0;
      const guaranteeLines = estimateHtmlLines(this.guaranteeHtml);
      return notesLines + appendixLines + responsiblesLines + guaranteeLines + (this.showAnticiposDetail ? 4 : 0);
    },
    commentsOuterHtml() {
      return this.dataProps.data.header.InvoiceInternalNote.replace(
        /<[^>]*>/g,
        ""
      );
    },
    modifiedBranchBilledInfo() {
      const info = this.dataProps.data.branch.BranchBilledInfo;
      if (info && info !== "") {
        return info.replace(/<p>/g, "").replace(/<\/p>/g, "<br/>");
      }

      return null;
    },
    dateWithDays() {
      let fecha = this.dataProps.data.header.InvoiceDate;
      let dias = this.dataProps.data.header.InvoiceCreditDay;

      const partesFecha = fecha.split("/");
      const dia = parseInt(partesFecha[0], 10);
      const mes = parseInt(partesFecha[1], 10) - 1;
      const anio = parseInt(partesFecha[2], 10);
      const fechaInicial = new Date(anio, mes, dia);

      const diasAgregar = parseInt(dias.split(" ")[0], 10);

      fechaInicial.setDate(fechaInicial.getDate() + diasAgregar);

      const diaNuevo = ("0" + fechaInicial.getDate()).slice(-2);
      const mesNuevo = ("0" + (fechaInicial.getMonth() + 1)).slice(-2);
      const anioNuevo = fechaInicial.getFullYear();

      return `${diaNuevo}/${mesNuevo}/${anioNuevo}`;
    },
    isMonsalSolution(){
      return '679f296532b2e6338c68854d96282b42' === this.keyMaster
    },
    getTotalAnticipo(){
      const total = this.dataProps?.data?.invoicePayments.reduce((acc, e) => {
        if (
          typeof e.DescriptionTypePayment === 'string' &&
          e.DescriptionTypePayment.toLowerCase().includes('anticipo')
        ) {
          acc += Number(e.TotalPayment || 0);
        }
        return acc;
      }, 0)

      return total ?? 0;
    },
    showAnticiposDetail(){
      return this.isMonsalSolution && this.getTotalAnticipo && this.getTotalAnticipo > 0;
    },
    appendixRows() {
      const rows = this.dataProps?.data?.header?.apendice;
      return Array.isArray(rows) ? rows : [];
    },
    hasAppendixRows() {
      return this.appendixRows.length > 0;
    },
    relatedDocuments() {
      if (Array.isArray(this.dataProps?.data?.docRelated) && this.dataProps.data.docRelated.length) {
        return this.dataProps.data.docRelated;
      }

      if (this.dataProps?.data?.ndornc) {
        return [this.dataProps.data.ndornc];
      }

      const dteRelatedDocuments =
        this.dataProps?.data?.dteJson?.documentoRelacionado ||
        this.dataProps?.data?.header?.JsonMh?.dteJson?.documentoRelacionado ||
        this.dataProps?.data?.header?.jsonMH?.documentoRelacionado ||
        [];

      if (Array.isArray(dteRelatedDocuments) && dteRelatedDocuments.length) {
        return dteRelatedDocuments.map((item) => ({
          TipoDocumentoRelacionado: item.TipoDocumentoRelacionado || item.tipoDocumento || null,
          NumeroDocumentoRelacionado:
            item.NumeroDocumentoRelacionado ||
            item.numeroDocumento ||
            item.codigoGeneracion ||
            null,
          FechaEmisionRelacionado: item.FechaEmisionRelacionado || item.fechaEmision || null,
        }));
      }

      return [];
    },
    isContadoEspecial() {
      const diasCreditoString = this.dataProps?.data?.header?.InvoiceCreditDay || 0;
      const diasCredito = Number(diasCreditoString.match(/\d+/)?.[0] ?? 0);

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      return (
        user?.showcashinvoiceswhen1day &&
        this.dataProps?.data?.header?.InvoiceStatusDescription === "Crédito" &&
        diasCredito === 1
      );
    },
  },
  watch: {
      "dataProps.show"(value) {
          if (value) {
              this.showData()
          }
      }
  },
  methods: {
    showIvaTotal() {
      const data = this.dataProps?.data || {};
      const header = data.header || {};
      if (header.InvoiceType === "FNS") {
        return false;
      }

      const relatedDocuments = [].concat(
        data.docRelated || [],
        header.docRelated || [],
        data.ndornc || header.ndornc || []
      );
      return !(header.InvoiceType === "FER" && relatedDocuments.some((document) =>
        ["14", "FNS"].includes(String(document?.TipoDocumentoRelacionado || document?.tipoDocumento))
      ));
    },
    async prepareGuarantee() {
      this.guaranteeHtml = await loadGuaranteeHtml(this, {
        businessId: this.guaranteeBusinessId,
        branchId: this.guaranteeBranchId,
        guaranteeType: "COMPROBANTE",
      });
      this.guaranteePlacementResolved = true;
      this.showGuaranteeInline = this.lastPageLimitRows
        ? (this.lastPageRowsUsed + this.tailReserveLines) <= this.lastPageLimitRows
        : false;
    },
    getEstadoFactura(){
      if (['9593c3ca31b86c09c9b764c5baddf846'].includes(this.keyMaster)) {
        if (this.isContadoEspecial) {
          return 'Pagado';
        }
        return this.dataProps?.data?.header?.InvoiceStatusDescription == 'Cancelada' ? 'Pagado' : this.dataProps?.data?.header?.InvoiceStatusDescription;
      }
      else {
        if (this.isContadoEspecial) {
          return 'Al Contado';
        }
        return this.dataProps?.data?.header?.InvoiceStatusDescription == 'Cancelada' ? 'Al Contado' : this.dataProps?.data?.header?.InvoiceStatusDescription;
      }
    },
    showData() {
      if (this.dataProps.show) {
        setTimeout(async () => {
          this.prepareGuarantee();
          await this.calculatePagesOfDoc();
          const partes = this.dataProps.data.header.InvoiceDate.split("/");
          const dia = partes[0];
          const mes = partes[1];
          const anio = partes[2];

          // Crear una nueva fecha en formato "yyyy-mm-dd"
          const fechaNueva = `${anio}-${mes}-${dia}`;
          const url =
            this.dataProps.data.branch.AuthFeMode == 1
              ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
              : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

          // Generar el código QR y mostrarlo en el elemento con id "qrcode"

          const opt = {
            errorCorrectionLevel: "H",
            type: "image/png",
            quality: 0.3,
            margin: 1,
            color: {
              dark: "#000000",
              light: "#ffffff",
            },
            width: 100,
          };

          QRCode.toDataURL(url, opt, (error, url) => {
            if (error) {
              console.log("Error al generar el código QR:", error);
              throw error;
            }
            this.urlQr = url;
          });
          await this.getImages();
        }, 0);
      }
    },
    GetnumberToText(number) {
      if (number) return numberToText(number);
      else return "";
    },
    numberWithCommas(x) {
      if(this.keyMaster === '55652726b965155654981d279f4900bf'){
        return formatNumber(x, 4)
      } 
      return formatNumber(x)
    },
    getHeaderFooter() {
      let search = {};
      search.ID_business =
        JSON.parse(localStorage.getItem("user")).businessid || "";
      search.ID_branch = JSON.parse(localStorage.getItem("user")).branch || "";
      this.$API.HF.getHF(search).then((data) => {
        let header = [],
          footer = [];
        header = data.filter((x) => x.State == "1" && x.Type == "Header");
        this.header = header.length > 0 ? JSON.parse(header[0].Body).html : "";
        this.header = this.header.replace(/(\n)/gm, "");
        footer = data.filter((x) => x.State == "1" && x.Type == "Footer");
        this.footer = footer.length > 0 ? JSON.parse(footer[0].Body).html : "";
      });
    },

    calculatePagesOfDoc() {
      const lines = 23;
      const rowsPerPage = Math.max(lines - 1, 1);
      const body = Array.isArray(this.dataProps?.data?.body)
        ? this.dataProps.data.body
        : [];
      const paginateRows = (items) => {
        this.valuesRows = [[]];
        let pageIndex = 0;
        let rowsOnPage = 0;

        items.forEach((item, index) => {
          if (rowsOnPage >= rowsPerPage) {
            pageIndex++;
            rowsOnPage = 0;
            this.valuesRows[pageIndex] = [];
          }

          this.valuesRows[pageIndex].push({
            ...item,
            itemNum: index + 1,
          });
          rowsOnPage++;
        });

        this.lastPageRowsUsed = rowsOnPage;
        this.lastPageLimitRows = rowsPerPage;
        return pageIndex + 1;
      };

      try {
        if (
          this.dataProps.data.branch.BusinessBillingNRC == "3213715" ||
          this.dataProps.data.branch.BusinessBillingNRC == "2201050"
        ) {
          this.typePrint = 1;
          this.numPages = paginateRows(body);
        } else {
          this.typePrint = 0;
          this.numPages = paginateRows(body);
        }
      } catch (err) {
        alert(err);
      }
    },
    async Print() {
      this.loading = true;
      await this.prepareGuarantee();
      var doc = new jsPDF("p", "pt", "letter");
      await doc.html(this.$refs.dataprint, {
        callback: function (doc) {
          doc.output();
        },
        x: 0,
        y: 0,
        margin: [0, 0, 0, 0],
        html2canvas: {
          scale: 0.612,
          useCORS: true,
          logging: false,
          allowTaint: true,
        },
      });

      doc.autoPrint({ variant: "non-conform" });
      const blob = doc.output("bloburl");
      window.open(blob);

      this.loading = false;
    },

    async Download() {
      this.loading = true;
      await this.prepareGuarantee();
      var doc = new jsPDF("p", "pt", "letter");
      doc.setFont("arial")
      await doc.html(this.$refs.dataprint, {
        callback: function (doc) {
          doc.output();
        },
        x: 0,
        y: 0,
        margin: [0, 0, 0, 0],
        html2canvas: {
          scale: 0.612,
          useCORS: true,
          logging: false,
          allowTaint: true,
        },
      });

      doc.save(
        this.dataProps.data.header.ID_Invoice +
          "_" +
          this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
          "_" +
          this.dataProps.data.header.InvoiceName.replaceAll(
            /[:/<>*|/]/g,
            ""
          ).replaceAll('\\"', "") +
          ".pdf"
      );

      this.loading = false;
    },
    async sendMail() {
      try {
        this.mailLabel = null;
        this.mailLabel = "Enviando...";
        await this.prepareGuarantee();
        var doc = new jsPDF("p", "pt", "letter");
        await doc.html(this.$refs.dataprint, {
          callback: function (doc) {
            doc.output();
          },
          x: 0,
          y: 0,
          margin: [0, 0, 0, 0],
          html2canvas: {
            scale: 0.612,
            useCORS: true,
            logging: false,
            allowTaint: true,
          },
        });

        this.assignCuerpoDocumento();

        const {
          data: {
            header: { jsonMH },
            dteJson: { ID_Invoice },
          },
        } = this.dataProps;

        const body = {
          dtefilebuffer: new Buffer.from(doc.output("arraybuffer")),
          dtejson: { ...jsonMH, ID_Invoice },
          dtefilebufferfilename:
            this.dataProps.data.header.ID_Invoice +
            "_" +
            this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
            "_" +
            this.dataProps.data.header.InvoiceName.replaceAll(
              /[:/<>*|/]/g,
              ""
            ).replaceAll('\\"', ""),
        };

        await this.$API.invoices.sendInvoiceMail(body);

        this.mailLabel = "Se envió el correo correctamente";
        this.$emit("mailSent");
      } catch (error) {
        this.mailLabel = `Ocurrió el siguiente error al enviar el correo ${error}`;
      }
    },
    assignCuerpoDocumento() {
      this.dataProps.data.header.jsonMH.cuerpoDocumento =
        this.dataProps.data.body.map((item, index) => ({
          descripcion: item.ItemDescription,
          montoDescu: item.ItemDiscount,
          codigo: item.ID_Item,
          ventaGravada: item.ItemGravada,
          ivaItem: item.ItemIva,
          ventaNoSuj: item.ItemNoSuj,
          ventaExenta: item.ItemExenta,
          numItem: index + 1,
          noGravado: item.ItemNoGravada,
          psv: item.ItemPsv,
          uniMedida: item.ItemMeasureUnit,
          cantidad: item.ItemQuantity,
          precioUni: item.ItemUnitPrice,
        }));
    },
    async downLoadJSON() {
      try {
        const selloRecibido =
          JSON.parse(this.dataProps.data.header.ResponseMhJson)
            ?.selloRecibido || "";
        const firmaElectronica =
          this.dataProps.data.header.JsonMhSigned?.documento || "";
        const jsonToSend = {
          ...this.dataProps.data.header.JsonMh.dteJson,
          firmaElectronica,
          selloRecibido,
        };
        delete jsonToSend.passwordPri;

        const aElement = document.createElement("a");
        aElement.setAttribute(
          "download",
          this.dataProps.data.header.ID_Invoice +
            "_" +
            this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
            "_" +
            this.dataProps.data.header.InvoiceName.replaceAll(
              /[:/<>*|/]/g,
              ""
            ).replaceAll('\\"', "") +
            ".pdf"
        );
        this.assignCuerpoDocumento();
        const blob = new Blob([JSON.stringify(jsonToSend)], {
          type: "application/json",
        });
        const href = URL.createObjectURL(blob);
        aElement.href = href;
        aElement.download =
          this.dataProps.data.header.ID_Invoice +
          "_" +
          this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
          "_" +
          this.dataProps.data.header.InvoiceName.replaceAll(
            /[:/<>*|/]/g,
            ""
          ).replaceAll('\\"', "") +
          ".json";
        aElement.click();
        URL.revokeObjectURL(href);
      } catch (error) {
        this.mailLabel = "Ocurrió un error al descargar JSON";
        console.log(error);
      }
    },
    async getImages() {
      const img = this.dataProps.data.branch.BranchBannerPath;
      const logo = this.dataProps.data.branch.BranchLogoPath;

      if (logo) {
        const LogoBranchBase64 = localStorage.getItem("LogoBranchBase64")

        if (LogoBranchBase64) {
          this.dataProps.data.branch.BranchLogoPath = `${LogoBranchBase64}`;
        }
        else {
          const { imageBase64: logoImageBase64 } = await this.$API.utilities.getImageInBase64({ file: logo });
          this.dataProps.data.branch.BranchLogoPath = `${logoImageBase64}`;
        }
      }
      
      if (img) {
        const { imageBase64: bannerImageBase64 } = await this.$API.utilities.getImageInBase64({ file: img });
        this.dataProps.data.branch.BranchBannerPath = `${bannerImageBase64}`;
      }
      
    },
    getMetodoPago(data){

       let formasDePago = {
        "01": "Billetes y monedas",
        "02": "Tarjeta Débito",
        "03": "Tarjeta Crédito",
        "04": "Cheque",
        "05": "Transferencia-Depósito Bancario",
        "08": "Dinero electrónico",
        "09": "Monedero electrónico",
        "11": "Bitcoin",
        "12": "Otras Criptomonedas",
        "13": "Cuentas por pagar del receptor",
        "14": "Giro bancario",
        "99": "Otros (se debe indicar el medio de pago)"
      };
      if (['9593c3ca31b86c09c9b764c5baddf846'].includes(this.keyMaster)) 
      formasDePago = {
        "01": "EFECTIVO",
        "02": "Tarjeta Débito",
        "03": "Tarjeta Crédito",
        "04": "Cheque",
        "05": "Transferencia-Depósito Bancario",
        "08": "Dinero electrónico",
        "09": "Monedero electrónico",
        "11": "Bitcoin",
        "12": "Otras Criptomonedas",
        "13": "Cuentas por pagar del receptor",
        "14": "Giro bancario",
        "99": "Otros (se debe indicar el medio de pago)"
      };
      const pagos = data?.JsonMh?.dteJson?.resumen?.pagos;
      if (!pagos || pagos.length === 0) {
        return "";
      }
      const descripciones = pagos.map(pago => formasDePago[pago.codigo]).join(", ");
      return descripciones;
      
    }
  },
};
</script>

<style scoped>
.u-row .u-col-100 {
  width: 100% !important;
}
.btnclean {
  border-radius: 15px;
  border: 1px solid white;
  background-color: #f29d35 !important;
  color: white !important;
}
.btnclose {
  border-radius: 15px;
  border: 1px solid white;
  background-color: rgb(255, 38, 38) !important;
  color: white !important;
}

* {
  font-family: Arial, Helvetica, sans-serif !important;
  letter-spacing: 0.01px;
}
</style>
